// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1IQIo","selects":"Documents_selects__33YS7"};